// Stripe Connect appearance configuration
export const stripeAppearance = {
    overlays: 'dialog',
    variables: {
        colorPrimary: '#076b8f',
        colorBackground: '#ffffff',
        colorText: '#30313d',
        colorDanger: '#ff4d4f',
        fontFamily: '"Inter", system-ui, sans-serif',
        borderRadius: '8px',
        spacingUnit: '4px',
    },
    rules: {
        '.Label': {
            fontWeight: '600',
        },
        '.Input': {
            borderColor: '#c9c9c9',
            boxShadow: 'none',
        },
        '.Input:focus': {
            borderColor: '#076b8f',
        },
    },
};

// Stripe publishable key
// At runtime, prefer the value injected into the container via a runtime config
// (window.__RUNTIME_CONFIG__), then fallback to build-time env, then to the
// existing test key for local development.
function getRuntimeConfigKey() {
    try {
        if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_STRIPE_PUBLISHABLE_KEY) {
            return window.__RUNTIME_CONFIG__.REACT_APP_STRIPE_PUBLISHABLE_KEY;
        }
    } catch (_) {
        // ignore
    }
    return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
}

const runtimeOrEnvKey = getRuntimeConfigKey();
if (!runtimeOrEnvKey && process.env.NODE_ENV === 'production') {
    // eslint-disable-next-line no-console
    console.error('REACT_APP_STRIPE_PUBLISHABLE_KEY not provided (runtime or build-time).');
}

export const STRIPE_PUBLISHABLE_KEY = runtimeOrEnvKey || 'pk_test_51RBgTP4N24mVF1iRKTct4DY748yTsFrkRC0XbFXfM8qaanHebE9ZPSOQdu3xxXqTIzLw9YLnnnGNbJwtHXKo9dSn00T2Ix9iYU';
